module.exports = __webpack_public_path__ + "img/logo-icon.3e6cb669.png";